import { IEvent } from "@Interfaces";
import { useSetQuantity } from "@Modules/eventPage/utils/merchandise";
import { useEventDataOfSelectedEvent } from "@Utils";
import { useEffect } from "react";

const useFlexibleAppointmentSelector = () => {
    const { event, eventData } = useEventDataOfSelectedEvent();
    const setQuantity = useSetQuantity();

    const {
        paymentInfo: { quantity, numberOfCustomers = 1 },
    }: IEvent.IStore = event;

    const {
        currency,
        price_per_head,
        updated_price,
        metadata: {
            max_flexible_sessions_per_payment,
            batched_flexible_sessions_count,
        },
    } = eventData;

    const price = price_per_head || updated_price;
    const maxQty = max_flexible_sessions_per_payment ?? 0;
    const hasQtyLimit = max_flexible_sessions_per_payment !== undefined;
    const hasBatchedSessions = batched_flexible_sessions_count !== undefined;

    useEffect(() => {
        if (hasBatchedSessions) setQuantity(batched_flexible_sessions_count);
    }, []);

    const getMaxCountReached = (isIncrement: boolean): boolean =>
        hasQtyLimit &&
        quantity * numberOfCustomers + (isIncrement ? 1 : -1) > maxQty;

    const handleQuantityChange = (isIncrement: boolean) => () => {
        if (getMaxCountReached(isIncrement))
            alert("Maximum available slots reached");
        else setQuantity(Math.max(1, quantity + (isIncrement ? 1 : -1)));
    };

    const handleIncreaseQty = () => handleQuantityChange(true);
    const handleDecreaseQty = () => handleQuantityChange(false);

    return {
        currency,
        price,
        quantity,
        disableDecreaseClick: quantity <= 1,
        disableIncreaseClick: getMaxCountReached(true),
        hasBatchedSessions,
        totalSlots: batched_flexible_sessions_count,
        handleIncreaseQty,
        handleDecreaseQty,
    };
};

export default useFlexibleAppointmentSelector;
